import getByUseItWithVariantIdProductSelector from 'modules/product/redux/selectors/get-by-perfect-your-look-variant-id'
import getSelectedUseItWithVariantIdProductSelect from 'modules/product/redux/selectors/get-selected-perfect-your-look-variant-id'

const getSelectedUseItWithVariantProductSelect = state => {
  const selectedVariantId = getSelectedUseItWithVariantIdProductSelect(state)
  return getByUseItWithVariantIdProductSelector(selectedVariantId)(state)
}

export default getSelectedUseItWithVariantProductSelect
